import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { QueryReportType } from '@app/feature/dealer/query-reports/query-report-type.enum';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var QueryReportsService = /** @class */ (function () {
    function QueryReportsService(http) {
        this.http = http;
    }
    QueryReportsService.prototype.queryReport = function (params, dealerId) {
        var from = params.queryFrom;
        this.queryReportType = params.queryReportType;
        var to = params.queryTo;
        if (this.isIndustry()) {
            this.requestParams = new HttpParams()
                .set('startInclusive', this.formatDate(from));
        }
        else {
            this.requestParams = new HttpParams()
                .set('startInclusive', this.formatDate(from))
                .set('endInclusive', this.formatDate(to))
                .set('reportType', params.reportType);
        }
        return this.sendRequestOfType('application/json', 'json', dealerId);
    };
    QueryReportsService.prototype.xls = function (dealerId) {
        var _this = this;
        return this.sendRequestOfType('application/vnd.ms-excel', 'blob', dealerId)
            .subscribe(function (response) {
            var fileName = _this.queryReportType.toLowerCase() + '-report' + (dealerId ? '-' + dealerId : '') + '.xls';
            if (window.navigator.msSaveOrOpenBlob) { // IE/Edge support (https://stackoverflow.com/questions/24007073/open-links-made-by-createobjecturl-in-ie11)
                var fileData = [response];
                var blobObject = new Blob(fileData);
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            }
            else {
                var anchorElement = document.createElement('a');
                document.body.appendChild(anchorElement);
                var url = window.URL.createObjectURL(response);
                anchorElement.setAttribute('style', 'display: none');
                anchorElement.href = url;
                anchorElement.download = fileName;
                anchorElement.click();
                window.URL.revokeObjectURL(url);
                anchorElement.remove();
            }
        });
    };
    QueryReportsService.prototype.print = function (dealerId) {
        var _this = this;
        return this.sendRequestOfType('application/pdf', 'blob', dealerId)
            .subscribe(function (response) {
            var fileName = _this.queryReportType.toLowerCase() + '-report' + (dealerId ? '-' + dealerId : '') + '.pdf';
            if (window.navigator.msSaveOrOpenBlob) { // IE/Edge support (https://stackoverflow.com/questions/24007073/open-links-made-by-createobjecturl-in-ie11)
                var fileData = [response];
                var blobObject = new Blob(fileData);
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            }
            else {
                var url = window.URL.createObjectURL(response);
                var anchorElement = document.createElement('a');
                document.body.appendChild(anchorElement);
                anchorElement.setAttribute('style', 'display: none');
                anchorElement.href = url;
                anchorElement.download = fileName;
                anchorElement.click();
                window.URL.revokeObjectURL(url);
                anchorElement.remove();
            }
        });
    };
    QueryReportsService.prototype.sendRequestOfType = function (contentType, myResponseType, dealerId) {
        var headers = new HttpHeaders({ 'Accept': contentType });
        var whoseReport = (this.queryReportType !== QueryReportType.industry.value) ? (dealerId ? dealerId : 'mine') + '/' : '';
        var url = 'dealers/' + whoseReport + 'reports/' + this.queryReportType.toLowerCase() + '/';
        return this.http.get(url, {
            params: this.requestParams,
            headers: headers,
            responseType: myResponseType
        });
    };
    QueryReportsService.prototype.formatDate = function (date) {
        var month = date.month, year = date.year;
        return year.toString() + '-' + (month > 9 ? month.toString() : '0' + month.toString());
    };
    QueryReportsService.prototype.isIndustry = function () {
        return this.queryReportType === QueryReportType.industry.value;
    };
    QueryReportsService.ngInjectableDef = i0.defineInjectable({ factory: function QueryReportsService_Factory() { return new QueryReportsService(i0.inject(i1.HttpClient)); }, token: QueryReportsService, providedIn: "root" });
    return QueryReportsService;
}());
export { QueryReportsService };
